/*--------------------------------------------------------------
# Custom scripts for Related post type block
--------------------------------------------------------------*/


const cardSlider = document.querySelectorAll('.post-news-events .swiper');
const cardSliderNext = document.querySelectorAll('.card-swiper-next');
const cardSliderPrev = document.querySelectorAll('.card-swiper-prev');

for( i = 0; i < cardSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    cardSlider[i].classList.add('swiper-' + i);
    cardSliderNext[i].classList.add('card-swiper-next-' + i);
    cardSliderPrev[i].classList.add('card-swiper-prev-' + i);

    var initCardSlider = new Swiper('.post-news-events .swiper-' + i, {
        simulateTouch: false,
        grabCursor: false,
        slidesPerView: 1,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.card-swiper-next-' + i,
            prevEl: '.card-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            }
        }
    });
}

const peopleSlider = document.querySelectorAll('.post-people .swiper');
const peopleSliderNext = document.querySelectorAll('.card-swiper-next-people');
const peopleSliderPrev = document.querySelectorAll('.card-swiper-prev-people');

for( i = 0; i < peopleSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    peopleSlider[i].classList.add('swiper-' + i);
    peopleSliderNext[i].classList.add('card-swiper-next-people' + i);
    peopleSliderPrev[i].classList.add('card-swiper-prev-people' + i);

    var initPeopleSlider = new Swiper('.post-people .swiper-' + i, {
        simulateTouch: false,
        grabCursor: false,
        slidesPerView: 1,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.card-swiper-next-people' + i,
            prevEl: '.card-swiper-prev-people' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            }
        }
    });
}

